module.exports = __webpack_public_path__ + "img/zyrtec_d_12_hour_allergy_medicine.daba9790.png";